import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {LicenseManager} from 'ag-grid-enterprise';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function() {};
  }
}

// AG-Grid License Key
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-098147}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Booz_Allen_Hamilton_Holding_Corporation}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TMSS}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{TMSS}_need_to_be_licensed___{TMSS}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{24_April_2027}____[v3]_[01]_MTgwODUyMTIwMDAwMA==23207ed0a40c19ff8fa6bd51b43e152e');

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
